import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import {
  IPublishedGraphic,
  IPublishedGraphicBaseLocationAWS,
} from '../../types/publishedGraphic'
import { triggerNotification } from '../../actions/notifications'
import { copyToClipboard } from '../../services/common'
import {
  getEditionPrimaryLocation,
  generateLynxJSON,
} from '../../services/publishedGraphic'
import { ActionsContainer, CopyLynxEditorLinkButton } from './styled'

interface IPublishedGraphicSidebar {
  publishedGraphic: IPublishedGraphic
  dispatch: Dispatch
}

const PublishedGraphicCopyLynxEditorLinkComponent = ({
  publishedGraphic,
  dispatch,
}: IPublishedGraphicSidebar) => {
  const primaryLocation = getEditionPrimaryLocation(
    publishedGraphic.publishing.locations
  )

  const handleCopyToLynx = (): void => {
    const jsonToCopy = generateLynxJSON(
      primaryLocation as IPublishedGraphicBaseLocationAWS,
      publishedGraphic,
      publishedGraphic.id,
      publishedGraphic.title,
      publishedGraphic.description,
      publishedGraphic.byline
    )

    copyToClipboard(jsonToCopy, () => {
      dispatch(triggerNotification('Copied'))
    })
  }

  return primaryLocation ? (
    <ActionsContainer>
      <CopyLynxEditorLinkButton
        type="button"
        variant="contained"
        color="primary"
        onClick={handleCopyToLynx}
      >
        Copy to LYNXEDITOR
      </CopyLynxEditorLinkButton>
    </ActionsContainer>
  ) : null
}

export const PublishedGraphicCopyLynxEditorLink = connect()(
  PublishedGraphicCopyLynxEditorLinkComponent
)
